import React from "react";
import canceladoImg from "../../assets/images/notifications/cancelado.png";
import facturaImg from "../../assets/images/notifications/factura.png";

export const FormNotification = ({
  notifications,
  hoveredId,
  setHoveredId,
  removeNotification,
  icon,
  handleNotificationAction

}) => {

  // console.log("🤖 notifications", notifications);

  return (
    <ul className="list-unstyled">
      {notifications.length > 0 ? (
        notifications.map((notification) => (
          <li
            key={notification.id}
            onClick={(e) => e.stopPropagation()}
    
            className=" notification-item w-100 bg-white p-2 shadow-sm mb-2"
            style={{
              transform: hoveredId === notification.id ? "scale(1.01)" : "scale(1)",
              backgroundColor: hoveredId === notification.id ? "#f7f7f7" : "white",
              boxShadow: hoveredId === notification.id
                ? "0px 2px 6px rgba(0, 0, 0, 0.15)"
                : "0px 1px 4px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
              // cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={() => setHoveredId(notification.id)}
            onMouseLeave={() => setHoveredId(null)}
>

            <div className="d-flex align-items-center">
           <img
              src={require(`../../assets/images/notifications/${icon}`)}
              style={{ width: "25px", height: "25px" }}
              alt="icon"
              className="mr-2"
            />

              <p className="text-sm text-left mb-0 ms-2 flex-grow-1 mr-3" style={{fontSize:"13px"}}>
                <strong>{notification.title}</strong>
              </p>
              <p className="text-sm text-left mb-0 ms-2 flex-grow-1" style={{ fontSize: "12px" }}>
                {notification.time}
              </p>
    
              {notification.can_delete &&
              <i
                className="fa fa-times text-gray-500"
                style={{
                  color: "#7bc6ed",
                  cursor: "pointer",
                  display: hoveredId === notification.id ? "block" : "none",

                }}
                 onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault(); 
                    removeNotification(notification.id);
                }}
                
              ></i>
              }
            </div>

           
               <div style={{ display: "flex", alignItems: "center" }}>
                  <p 
                    className="text-xs mt-1" 
                    style={{ fontSize: "11px", margin: 0 }}
                  >
                    {notification.message}
                  </p>
                  
                 {notification.action_type && (
                    <button
                      className="btn btn-sm"
                      style={{
                        fontSize: "11px",
                        padding: "4px 8px",
                        whiteSpace: "nowrap",
                        marginLeft: "auto",
                        borderRadius: "6px",
                        background: "#057fb9",
                        color: 'white'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNotificationAction(notification);
                      }}
                    >
                      <i className="fa fa-external-link"></i>
                    </button>
                  )}
                </div>
          </li>
        ))
      ) : (
        <p className="text-center text-gray-500">No hay notificaciones</p>
      )}
    </ul>
  );
};


